import { mapActions, mapState } from 'vuex';
import contentLoaderMixin from '@/mixins/contentLoader';
import socialLevelMixin from '@/mixins/socialLevel';
import { getOrdinalSuffix } from '@/utils/helpers';

export default {
  mixins: [
    contentLoaderMixin,
    socialLevelMixin,
  ],
  computed: {
    ...mapState('leaderboards', ['playerLeaderboards']),
    ...mapState('profile', ['settings']),
    items() {
      if (this.playerLeaderboards.length === 0 && this.isSocialReady) {
        const items = [
          {
            leaderBoardId: 0,
            leaderBoardName: 'All Predictors',
            leaderBoardPosition: 100,
            predefined: true,
          },
        ];
        if (this.level.num > 1) {
          items.push({
            leaderBoardId: this.level.num,
            leaderBoardName: this.level.text,
            leaderBoardPosition: 100,
            predefined: true,
          });
        }
        return items;
      }
      return this.playerLeaderboards;
    },
    showLeaderboards() {
      return (this.settings.privacy) ? this.settings.privacy.AllowLeaderboard : true;
    },
  },
  methods: {
    ...mapActions('leaderboards', ['getPlayerLeaderboards']),
    getOrdinalSuffix,
    sectionClassModifiers() {
      return {
        'leaderboards-info-section': true,
        'leaderboards-info-section--clickable': true,
      };
    },
    onSectionClick(item) {
      // if (item.predefined) return;
      this.$router.push({
        name: 'leaderboards',
        query: {
          leaderboardId: item.leaderBoardId,
        },
      });
    },
  },
  created() {
    this.getPlayerLeaderboards()
      .then(() => {
        this.isComponentReady = true;
      });
  },
};



// WEBPACK FOOTER //
// ./src/components/leaderboards/leaderboards-info/leaderboards-info.js